<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="حبر-العناقيد">
<h1><span dir="rtl">حبر العناقيد</span></h1>
<p><span dir="rtl">إنسان عادي متواضع..</span></p>
<p><span dir="rtl">أحبَّ الخير لكلِّ الناس..</span></p>
<p><span dir="rtl">متزوّج ولديه أربعة أبناء صبيان وبنتان</span></p>
<p><span dir="rtl">يعيشون في منزل صغير بالإيجار.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?b8ac978a